import {useMutation} from 'react-query';
import { BASE_API_URL } from '@env';

export function useVerifyOtp() {
  return useMutation(async ({email, password, otp}: {email: string; password: string; otp: string}) => {
    const response = await fetch(`${BASE_API_URL}/users/auth/verify`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
      body: JSON.stringify({email, password, otp}),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'OTP verification failed');
    }
    return response.json();
  });
} 